<form [formGroup]="formGroup">
  <ng-container *ngIf="!(isLoading$ | async); else loading">
    <div class="d-flex flex-column gap-4">
      <app-primary-back-button (backClicked)="goBack()" label="Step 1" i18n-label />
      <div>
        <div class="form-grid">
          <div class="d-flex flex-column gap-2">
            <label class="form-input-label" [for]="'primaryPhoneNumber'" i18n>Primary Phone Number</label>
            <app-phone-country-code
              controlId="primaryPhoneNumber"
              [countryCodes]="countryCodes$ | async"
              [formGroup]="formGroup"
              [error]="formGroup?.controls?.primaryPhoneNumber?.invalid && formSubmitted"
              [phoneNumberControlName]="'primaryPhoneNumber'"
              [countryCodeControlName]="'primaryPhoneNumberCountryCode'" />
            <app-form-error
              *ngIf="formSubmitted && formGroup?.controls?.primaryPhoneNumber?.invalid"
              [errors]="formGroup?.controls?.primaryPhoneNumber?.errors" />
          </div>
          <div class="d-flex flex-column gap-2">
            <label class="form-input-label" [for]="'secondaryPhoneNumber'" i18n>Secondary Phone Number</label>
            <app-phone-country-code
              controlId="secondaryPhoneNumber"
              [countryCodes]="countryCodes$ | async"
              [formGroup]="formGroup"
              [error]="formGroup?.controls?.secondaryPhoneNumber?.invalid && formSubmitted"
              [phoneNumberControlName]="'secondaryPhoneNumber'"
              [countryCodeControlName]="'secondaryPhoneNumberCountryCode'" />
            <app-form-error
              *ngIf="formSubmitted && formGroup?.controls?.secondaryPhoneNumber?.invalid"
              [errors]="formGroup?.controls?.secondaryPhoneNumberCountryCode?.errors" />
            <div class="form-input-hint" i18n>Optional</div>
          </div>
        </div>

        <hr class="address-divider" />

        <app-international-address-form-grid
          controlIdPrefix="selfEnrolmentAddress"
          [form]="formGroup.controls.address"
          [formSubmitted]="formSubmitted" />
      </div>
      <app-primary-button [size]="BaseButtonSizeEnum.md" (buttonClicked)="submit()" class="submit-button" i18n>
        Continue
      </app-primary-button>
    </div>
  </ng-container>
</form>

<ng-template #loading>
  <div class="d-flex flex-column gap-4">
    <div>
      <div class="form-grid">
        <div class="d-flex flex-column gap-2" *appRepeat="2">
          <lib-loading-shimmer [height]="'1.25rem'" [width]="'5rem'" />
          <lib-loading-shimmer [height]="'3.5rem'" [width]="'100%'" />
        </div>
      </div>

      <hr class="address-divider" />

      <app-international-address-form-grid [form]="formGroup.controls.address" [isLoading]="true" />
    </div>
  </div>
</ng-template>
